import { render, staticRenderFns } from "./CanceledTable.vue?vue&type=template&id=27d8b145&"
import script from "./CanceledTable.vue?vue&type=script&lang=js&"
export * from "./CanceledTable.vue?vue&type=script&lang=js&"
import style0 from "./CanceledTable.vue?vue&type=style&index=0&id=27d8b145&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports